// Claims Summary  info form config

export const claimsSummaryFields = [
    {
        key: 'administration',
        name: 'Administration',
        fields: [
            {
                tab: 'claim_info',
                name: 'claims_reference_number',
                label: 'Claims Reference Number',
                type: 'text',
                validation: {},
            },
            {
                tab: 'claim_info',
                name: 'claims_owner',
                label: 'Claims Owner',
                type: 'text',
                validation: {},
            },
            {
                tab: 'claim_info',
                name: 'claim_owner_telephone_number',
                label: 'Claims Owner Telephone Number',
                type: 'text',
                validation: {},
            },
            {
                tab: 'claim_info',
                name: 'claim_owner_email_address',
                label: 'Claim Owner Email Address',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'client-information',
        name: 'Client Information',
        fields: [
            {
                tab: 'claim_info',
                name: 'client',
                label: 'Client',
                type: 'text',
                validation: {},
            },
            {
                tab: 'claim_info',
                name: 'client_handler',
                label: 'Client Handler',
                type: 'text',
                validation: {},
            },
            {
                tab: 'claim_info',
                name: 'client_contact_number',
                label: 'Client Contact Number',
                type: 'text',
                validation: {},
            },
            {
                tab: 'claim_info',
                name: 'client_email_address',
                label: 'Client Email Address',
                type: 'text',
                validation: {},
            },
            {
                tab: 'claim_info',
                name: 'client_policy_number',
                label: 'Client Policy Number',
                type: 'text',
                validation: {},
            },
            {
                tab: 'claim_info',
                name: 'client_claims_ref_nb',
                label: 'Client Claims Reference Number',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'parties-information',
        name: 'Parties Information',
        fields: [
            {
                tab: 'claim_info',
                name: 'defendant_name',
                label: 'Defendant Name',
                type: 'text',
                validation: {},
            },
            {
                tab: 'claim_info',
                name: 'claimant_name',
                label: 'Claimant Name',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'coverage-information',
        name: 'Coverage Information Page',
        fields: [
            {
                tab: 'claim_info',
                name: 'accident_date',
                label: 'Accident Date',
                type: 'date',
                validation: {},
            },
            {
                tab: 'claim_info',
                name: 'liability_status',
                label: 'Liability Status',
                type: 'text',
                validation: {},
            },

            {
                tab: 'claim_info',
                name: 'indemnity_status_defendant',
                label: 'Indemnity Status - Defendant',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'claims-summary',
        name: 'Claims Summary Page',
        fields: [
            {
                tab: 'status',
                name: '',
                label: 'Claim Status',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'cho-summary',
        name: 'Credit Hire Organisation Information Page',
        fields: [
            {
                tab: 'claimant_reps',
                name: 'credit_hire_organisation',
                label: 'Credit Hire Organisation',
                type: 'text',
                validation: {},
            },
            {
                tab: 'claimant_reps',
                name: 'cho_ref',
                label: 'Credit Hire Organisation Reference',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'solicitors-information',
        name: 'Claimant Solicitors Information Page',
        fields: [
            {
                tab: 'claimant_reps',
                name: 'claimant_solicitor_name',
                label: 'Claimant Solicitor Name',
                type: 'text',
                validation: {},
            },
            {
                tab: 'claimant_reps',
                name: 'claimant_solicitor_ref',
                label: 'Claimant Solicitor Reference',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'def-vehicle-information',
        name: 'Defendant Vehicle Information',
        fields: [
            {
                tab: 'vehicles',
                name: 'defendant_vehicle_reg',
                label: 'Defendant Vehicle Reg',
                type: 'text',
                validation: {},
            },
            {
                tab: 'vehicles',
                name: 'defendant_vehicle_make',
                label: 'Defendant Vehicle Make',
                type: 'text',
                validation: {},
            },
            {
                tab: 'vehicles',
                name: 'defendant_vehicle_model',
                label: 'Defendant Vehicle Model',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'claim-vehicle-information',
        name: 'Claimant Vehicle Information',
        fields: [
            {
                tab: 'vehicles',
                name: 'claimant_vehicle_reg',
                label: 'Claimant Vehicle Reg',
                type: 'text',
                validation: {},
            },
            {
                tab: 'vehicles',
                name: 'claimant_vehicle_make',
                label: 'Claimant Vehicle Make',
                type: 'text',
                validation: {},
            },
            {
                tab: 'vehicles',
                name: 'claimant_vehicle_model',
                label: 'Claimant Vehicle Model',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'reserve-information',
        name: 'Reserve Information Page',
        fields: [
            {
                tab: 'reserve',
                name: 'grand_total_reserved',
                label: 'Grand Total Reserved',
                type: 'text',
                validation: {},
            },
            {
                tab: 'payment_pack',
                name: 'grand_total_claimed',
                label: 'Grand Total Claimed',
                type: 'text',
                validation: {},
            },
            {
                tab: 'offers_payments',
                name: 'grand_total_offered',
                label: 'Grand Total Offered',
                type: 'text',
                validation: {},
            },
            {
                tab: 'offers_payments',
                name: 'grand_total_paid',
                label: 'Grand Total Paid',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'claim-vehicle-damage',
        name: 'Claimant Vehicle Damage Page',
        fields: [
            {
                tab: 'vehicle_damage',
                name: 'roadworthy_status',
                label: 'Vehicle Roadworthy?',
                type: 'boolean',
                validation: {},
            },
            {
                tab: 'vehicle_damage',
                name: 'party_dealing_with_ad_claim',
                label: 'Party Dealing with AD Claim',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'hire-lou-information',
        name: 'Hire Loss of Use Information',
        fields: [
            {
                tab: 'loss_of_use',
                name: 'hire_start_date_1',
                label: 'Hire Start Date (1)',
                type: 'date',
                validation: {},
            },
        ],
    },
    {
        key: 'pp-information',
        name: 'Payment Pack Information Page',
        fields: [
            {
                tab: 'payment_pack',
                name: 'payment_pack_received',
                label: 'Payment Pack Received',
                type: 'date',
                validation: {},
            },
            {
                tab: 'payment_pack',
                name: 'date_of_payment_pack',
                label: 'Date of Payment Pack',
                type: 'date',
                validation: {},
            },
            {
                tab: 'payment_pack',
                name: 'losses_included',
                label: 'Losses Included',
                type: 'float',
                validation: {},
            },
            {
                tab: 'payment_pack',
                name: 'date_of_1_st_lpp_clock',
                label: 'Date of 1st LPP clock',
                type: 'date',
                validation: {},
            },
            {
                tab: 'payment_pack',
                name: 'date_removed_from_abi_gta',
                label: 'Date removed from ABI GTA',
                type: 'date',
                validation: {},
            },
        ],
    },
    {
        key: 'litigation-information',
        name: 'Litigation Information Page',
        fields: [
            {
                tab: 'litigation',
                name: 'proceedings_received',
                label: 'Proceedings Received?',
                type: 'text',
                validation: {},
            },
            {
                tab: 'litigation',
                name: 'judgment_received',
                label: 'Judgment Received?',
                type: 'boolean',
                validation: {},
            },
            {
                tab: 'litigation',
                name: 'date_legal_supply_instructed',
                label: 'Legal Supplier Instructed',
                type: 'date',
                validation: {},
            },
            {
                tab: 'litigation',
                name: 'legal_supplier_ref',
                label: 'Legal Supplier Reference',
                type: 'text',
                validation: {},
            },
            {
                tab: 'litigation',
                name: 'legal_supplier_handler',
                label: 'Legal Supplier Handler',
                type: 'text',
                validation: {},
            },
            {
                tab: 'litigation',
                name: 'legal_supplier_handler_contact_nb',
                label: 'Legal Supplier Handler Contact Number',
                type: 'text',
                validation: {},
            },
            {
                tab: 'litigation',
                name: 'legal_supplier_handler_email_address',
                label: 'Legal Supplier Handler Email Address',
                type: 'text',
                validation: {},
            },
        ],
    },
];
